import { render, staticRenderFns } from "./LKPassportIndex.vue?vue&type=template&id=4b71406f&"
import script from "./LKPassportIndex.vue?vue&type=script&lang=js&"
export * from "./LKPassportIndex.vue?vue&type=script&lang=js&"
import style0 from "./LKPassportIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports